export const SALE_START_TIME = new Date("2025-05-31T23:59:59");
